<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'SELLERS.ACCESS_CONTROL_DIALOG_TITLE' | translate }}
    </h3>
    <div
      *ngIf="seller?.blocked_reason"
      class="sp-padding sp-text__italic">
      <strong>{{ 'SELLERS.LOCK_REASON_LABEL' | translate }}:</strong>
      {{ seller?.blocked_reason || '' }}
    </div>
    <div class="sp-padding">
      {{ 'SELLERS.ACCESS_CONTROL_DIALOG_MESSAGE' | translate : { email: seller?.email } }}
    </div>

    <app-shared-button
      class="sp-width__full"
      [button_class]="'sp-button__main'"
      [spinner_class]="'sp-spinner__main'"
      [icon]="'lock_open'"
      [cta]="'GENERAL.UNBLOCK_USER_CTA'"
      [is_disabled]="isBlocked() || is_seller_edit_running"
      [is_spinner_visible]="is_seller_edit_running"
      (click)="unblock(this.seller!)"></app-shared-button>
  </div>
</div>
